(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    
  function scrollBreadcrumbsToEnd() {
    const container = document.getElementById('breadcrumbs-container');
    if (container && container.scrollWidth > container.clientWidth) {
      container.scrollLeft = container.scrollWidth;
    }
  }

  document.addEventListener('filters-applied', scrollBreadcrumbsToEnd);
  document.addEventListener('DOMContentLoaded', scrollBreadcrumbsToEnd);

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList' && mutation.target.id === 'breadcrumbs') {
        scrollBreadcrumbsToEnd();
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const breadcrumbs = document.getElementById('breadcrumbs');
    if (breadcrumbs) {
      observer.observe(breadcrumbs, { childList: true, subtree: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.headerState = 'reset';
      this.stickyHeaderHeight = 0;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.setStickyHeaderOffset(true);
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      // Get announcement bar height - it's rendered before the sticky header
      const announcementBar = document.querySelector('.announcement-bar-section');
      const announcementBarHeight =
        announcementBar && window.getComputedStyle(announcementBar).display !== 'none'
          ? announcementBar.offsetHeight
          : 0;

      const headerHeight = this.header ? this.header.offsetHeight : 0;
      const totalHeaderHeight = announcementBarHeight + headerHeight;
      this.stickyHeaderHeight = headerHeight;

      document.documentElement.style.setProperty('--header-height', `${totalHeaderHeight}px`);
      document.documentElement.style.setProperty('--sticky-header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty(
        '--sticky-header-offset',
        this.headerIsAlwaysSticky ? `${headerHeight}px` : '0px',
      );
    }

    setStickyHeaderOffset(isVisible) {
      if (isVisible) {
        this.stickyHeaderHeight = this.header ? this.header.offsetHeight : 0;
      }
      const offset = isVisible ? `${this.stickyHeaderHeight}px` : '0px';

      document.documentElement.style.setProperty('--sticky-header-offset', offset);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && this.searchModal.isOpen()) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerState === 'hidden') return;

      this.headerState = 'hidden';
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.setStickyHeaderOffset(false);
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerState === 'revealed') return;

      this.headerState = 'revealed';
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setStickyHeaderOffset(true);
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerState === 'reset') return;

      this.headerState = 'reset';
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.setStickyHeaderOffset(false);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-search"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sectionEl =
      document.currentScript?.closest('.support-search-section') ||
      document.querySelector('.support-search-section');
    if (!sectionEl) return;

    const triggerEl = sectionEl.querySelector(
      '.support-search-container .support-search-trigger',
    );
    if (!triggerEl) return;

    const openHubspotChat = () => {
      if (
        window.HubSpotConversations &&
        window.HubSpotConversations.widget &&
        typeof window.HubSpotConversations.widget.open === 'function'
      ) {
        window.HubSpotConversations.widget.open();
      }
    };

    triggerEl.addEventListener('click', openHubspotChat);
  });

  } catch(e) { console.error(e); }
})();
})();
